export type Candidate = { coachingId: string; vorname: string; nachname: string }

export type MatchResult =
  | { kind: 'match'; candidate: Candidate }
  | { kind: 'none' }
  | { kind: 'ambiguous' }

export function normalize(value: string): string {
  return value
    .toLowerCase()
    .trim()
    .replace(/-/g, ' ')
    .replace(/ä/g, 'ae')
    .replace(/ö/g, 'oe')
    .replace(/ü/g, 'ue')
    .replace(/ß/g, 'ss')
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
}

export function matchTeilnehmende(
  person: { vorname: string | null | undefined; nachname: string | null | undefined },
  candidates: Candidate[],
): MatchResult {
  const vorname = person.vorname?.trim()
  const nachname = person.nachname?.trim()
  if (!vorname || !nachname) return { kind: 'none' }
  const vornameKey = normalize(vorname)
  const nachnameKey = normalize(nachname)
  const hits = candidates.filter(
    (c) => normalize(c.vorname) === vornameKey && normalize(c.nachname) === nachnameKey,
  )
  if (hits.length === 0) return { kind: 'none' }
  if (hits.length > 1) return { kind: 'ambiguous' }
  return { kind: 'match', candidate: hits[0] }
}
